/**
 * Festivals & Special Events — editorial grammar (docs/DAILY_PANCHANGA_UI_SPEC.md
 * §8.5), bulleted list. Rendered twice by DailyPanchangaView (desktop + mobile) —
 * one component so the copies can never drift (B-048 decomposition).
 */
import React from 'react';

export default function FestivalsCard({ festivals }: { festivals: string[] }) {
  return (
    <section className="kg-warm rounded-2xl p-5" style={{ background: 'var(--kg-card)', border: '1px solid var(--kg-line)', boxShadow: 'var(--kg-shadow)' }}>
      <h3 className="mb-3 font-fraunces text-[18px] font-medium" style={{ color: 'var(--kg-ink)' }}>Festivals &amp; Special Events</h3>
      <ul className="space-y-1.5">
        {festivals.map((f, idx) => (
          <li key={idx} className="flex items-baseline gap-2 text-[14px]" style={{ color: 'var(--kg-ink)' }}>
            <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full" style={{ background: 'var(--kg-sub)' }} aria-hidden="true" />
            {f}
          </li>
        ))}
      </ul>
    </section>
  );
}
